// extracted by mini-css-extract-plugin
export default {"root":"XN464l9kzc","header":"FgRR3fQrWh","search":"x3vdL8dFCw","content":"oNkoeyuMh_"};